import { businessConnectionType, eligibleBillingProvider } from '@libs/enums';
import { CheckboxGroupField } from '@ps-smart-cp/ppfw-client';
import { businessConnectionMstListSearchFieldConfig } from '../item-config';
import type { BusinessConnectionMstListSearch } from '../models';

export function AdditionalSearchBasicInfo(
  mstSearch: BusinessConnectionMstListSearch,
  setMstSearch: (t: BusinessConnectionMstListSearch) => void,
  errorFields?: string[],
) {
  return (
    <>
      <CheckboxGroupField
        items={businessConnectionMstListSearchFieldConfig}
        obj={mstSearch}
        setObj={setMstSearch}
        prop="businessConnectionClass"
        enumType={businessConnectionType.enum}
        enumNameConfig={businessConnectionType.nameConfig}
        errorFields={errorFields}
      />
      <CheckboxGroupField
        items={businessConnectionMstListSearchFieldConfig}
        obj={mstSearch}
        setObj={setMstSearch}
        prop="eligibleBillingProviderCondition"
        enumType={eligibleBillingProvider.enum}
        enumNameConfig={eligibleBillingProvider.nameConfig}
        errorFields={errorFields}
      />
    </>
  );
}
